module.exports = __webpack_public_path__ + "static/media/slideshow5.1c20e6a0.jpg";